import React, {useContext} from 'react';
import SearchView from "../SearchView";
import Details from "../Details"
import PriorAuthorizationContext from "../../../contexts/PriorAuthorization/PriorAuthorization.context";
import Banner from '../../Common/Banner'
import {apiStatus} from "../../../shared/enums";
import Loading from '../../Loading';
import {Grid} from '@material-ui/core'
import CancelSuccess from "../CancelSuccess/CancelSuccess";

export default function OperationsContainer(){
    const { status, bannerProps, setBanner, inquiry: { view } } = useContext(PriorAuthorizationContext);
    const clearBanner = () => {
        setBanner({message: null})
    }
    return(
        <Grid container justify='center'>
            <Banner
                style={{padding: '0.5rem 1rem'}}
                onClick={clearBanner}
                {...bannerProps}
            />
            {status === apiStatus.LOADING && <Loading />}
            {view === 'summary' && <Details /> }
            {view === 'cancelSuccess' && <CancelSuccess /> }
            {view === 'results' && <SearchView />}
        </Grid>
    )
}